import { kebabCase } from "utils/kebabCase";

export const getDataAttributeByPropertyName = (propertyName: string) =>
    "data-" + kebabCase(propertyName);
